/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetSourceMergePreview200ResponseData } from './GetSourceMergePreview200ResponseData';
import {
    GetSourceMergePreview200ResponseDataFromJSON,
    GetSourceMergePreview200ResponseDataFromJSONTyped,
    GetSourceMergePreview200ResponseDataToJSON,
} from './GetSourceMergePreview200ResponseData';

/**
 * 
 * @export
 * @interface GetSourceMergePreview200Response
 */
export interface GetSourceMergePreview200Response {
    /**
     * 
     * @type {GetSourceMergePreview200ResponseData}
     * @memberof GetSourceMergePreview200Response
     */
    data: GetSourceMergePreview200ResponseData;
}

/**
 * Check if a given object implements the GetSourceMergePreview200Response interface.
 */
export function instanceOfGetSourceMergePreview200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetSourceMergePreview200ResponseFromJSON(json: any): GetSourceMergePreview200Response {
    return GetSourceMergePreview200ResponseFromJSONTyped(json, false);
}

export function GetSourceMergePreview200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSourceMergePreview200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetSourceMergePreview200ResponseDataFromJSON(json['data']),
    };
}

export function GetSourceMergePreview200ResponseToJSON(value?: GetSourceMergePreview200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetSourceMergePreview200ResponseDataToJSON(value.data),
    };
}

